import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DiagnosticDto } from '../../beneficiaries/beneficiary-folder/diagnostic/diagnostic-details/diagnosticDto';
import { DiagnosticInit } from '../../beneficiaries/beneficiary-folder/diagnostic/diagnosticInit';
import { DisplayDiagnosticDto } from '../../beneficiaries/beneficiary-folder/diagnostic/displayDiagnosticDto';
import { environment } from '../../environments/environment';
import { Pagination } from '../pagination/pagination';
import { PaginationOptions } from '../pagination/pagination-options';
import { ApiService, FileResponse } from './api.service';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root',
})
export class DiagnosticService {
  private readonly diagnosticCreate: Subject<DiagnosticDto> = new Subject<DiagnosticDto>();
  public diagnosticCreated$: Observable<DiagnosticDto> = this.diagnosticCreate.asObservable();
  constructor(private readonly api: ApiService, private readonly fileService: FileService) {}

  public async findByBeneficiaryId(idBeneficiary: number): Promise<DiagnosticInit> {
    const url: string = environment.api.diagnostics + '/' + idBeneficiary + '/init';
    const result: DiagnosticInit = await this.api.get<DiagnosticInit>(url);

    return DiagnosticInit.fromJson(result);
  }

  public async findDiagnostics(id: number, options: PaginationOptions): Promise<Pagination<DisplayDiagnosticDto>> {
    const uri: string = environment.api.diagnostics + '/' + id;
    return this.api.getPaginated<DisplayDiagnosticDto>(options.buildUrl(uri));
  }

  public async saveDiagnostic(diagnostic: DiagnosticDto): Promise<void> {
    await this.api.post<void, DiagnosticDto>(environment.api.diagnostics, diagnostic);
    this.diagnosticCreate.next(diagnostic);
  }

  public async findByDiagnosticId(diagnosticId: number): Promise<DiagnosticDto> {
    const uri: string = environment.api.diagnostics + '/' + diagnosticId + '/details';
    const result: DiagnosticDto = await this.api.get<DiagnosticDto>(uri);
    if (result) {
      return DiagnosticDto.fromJson(result);
    }
  }

  public async downloadDocument(diagnosticId: number): Promise<void> {
    const uri: string = environment.api.diagnostics + '/' + diagnosticId + '/document';
    const { filename, data }: FileResponse = await this.api.getFileWithName(uri);
    return this.fileService.saveAs(data, filename);
  }

  public async delete(id: number): Promise<void> {
    await this.api.delete(environment.api.diagnostics + '/' + id);
    this.diagnosticCreate.next(undefined);
  }
}
